import { defineMessages } from 'react-intl'

const messages = defineMessages({
  rating9: {
    id: 'score.range-1',
  },
  rating8: {
    id: 'score.range-2',
  },
  rating7: {
    id: 'score.range-3',
  },
  rating6: {
    id: 'score.range-4',
  },
})

export default messages
